import { Injectable } from '@angular/core';

import { LocalizationService } from '../services/localization.service';
import { PgFormLayout } from '../models/form.model';
import { PGUtilities } from '../utilities/pg-utilities';

export class SaveStatusRequest {
    constructor(public mode:'edit'|'create', 
        public label:string, 
        public onAction:(action:string) => void|Promise<void>, 
        public actions?:{ [name:string]: boolean }, 
        public onToggle?:(action:string, value:boolean) => void, 
        public toggles?:{ [name:string]: boolean },
        public onLanguage?:(language:string) => void,
        public languages?:Array<string>,
        public goToLanguagesManagement?:(languages:Array<string>) => void,
        public topic?:string) {
        if(actions == null) {
            this.actions = { save: true }
        }

        if(toggles == null) {
            this.toggles = { }
        }
    }

    status:'running'|'success'|'error' = null;

    hidden = false;
    disabled = false;

    changed = false;

    private _statusTimeout = null;

    runAction(name:string) {
        if(this.actions[name] && !this.hidden && !this.disabled && this.status != 'running') {
            let _actionResult = this.onAction(name);

            if(typeof _actionResult != 'undefined') { // TODO: se ci saranno azioni multiple bisognerà tracciale quale è running per gestire il singolo bottone
                clearTimeout(this._statusTimeout)
                this.status = 'running';

                _actionResult.then(() => {
                    this.status = 'success';
                    this._statusTimeout = setTimeout(() => {
                        this.status = null;
                    }, 2000)

                    if(name == 'save' || name == 'delete') {
                        this.changed = false;
                    }
                }, () => {
                    this.status = 'error';
                    this._statusTimeout = setTimeout(() => {
                        this.status = null;
                    }, 2000)
                })
            }
            else {
                if(name == 'save' || name == 'delete') {
                    this.changed = false;
                }
            }
        }
    }

    toggleValues:{ [name:string]: boolean } = {}

    setToggle(name:string, value:boolean) {        
        if(this.toggleValues[name] != value) {
            this.toggleValues[name] = value;
            this.onToggle(name, value)
        }
    }

    selectedLanguage:string = null;

    setLanguage(value:string) {
        if(this.selectedLanguage != value) {
            this.selectedLanguage = value;
            this.onLanguage(value)
        }
    }

    getLanguagesFromForm(form:PgFormLayout, availableLanguages:Array<string>) {
        let _languagesField = form.getFieldByName('languages');
        
        if(_languagesField == null) {
            this.languages = null;
        }
        else {
            this.languages = PGUtilities.tryParseJSON(_languagesField.value);

            if(this.languages == null) {
                this.languages = []
                this.setLanguage(availableLanguages[0])
            }
            else {
                if(this.selectedLanguage == null || this.languages.indexOf(this.selectedLanguage) == -1) {
                    for(let _language of availableLanguages) {
                        if(this.languages.indexOf(_language) != -1) {
                            this.setLanguage(_language)
                            break;
                        }
                    }
                }
            }
        }      
    }
}

@Injectable({
  providedIn: 'root'
})
export class SaveStatusService {

    constructor() {
        window.addEventListener('beforeunload', (e) => {
            if(this.hasChangedRequests()) {
                e.preventDefault();
                e.returnValue = '';
            }
        });
    }

    enabled = false;

    private _requestList:Array<SaveStatusRequest> = []

    createRequest(mode:'edit'|'create', label:string, 
        onAction:(action:string) => void|Promise<void>, actions?:{ [name:string]: boolean }, 
        onToggle?:(toggle:string, value:boolean) => void, toggles?:{ [name:string]: boolean }, 
        onLanguage?:(language:string) => void, languages?:Array<string>, 
        goToLanguagesManagement?:(languages:Array<string>) => void,
        topic?:string) {
        if(!this.isActive()) {
            console.error('SaveStatusService not active!')
            throw null;
        }
        else {
            let _request = new SaveStatusRequest(mode, label, onAction, actions, onToggle, toggles, onLanguage, languages, goToLanguagesManagement, topic);

            if(topic != null) {
                this.clearTopic(topic);
            }

            this._requestList.push(_request);

            return _request;
        }
    }

    removeRequest(request:SaveStatusRequest) {
        let _index = this._requestList.indexOf(request);

        if(_index != -1) {
            this._requestList.splice(_index, 1);
        }
    }

    clearTopic(topic:string) {
        for(let i = this._requestList.length - 1; i >= 0; i--) {
            if(this._requestList[i].topic == topic) {
                this._requestList.splice(i, 1);
            }
        }
    }

    hasChangedRequests() {
        for(let _request of this._requestList) {
            if(_request.changed) return true;
        }
    }

    private _listenerCount = 0;

    isActive() {
        return this._listenerCount > 0;
    }

    addListener() {
        this._listenerCount++;
        return this._requestList;
    }

    removeListener() {
        this._listenerCount--;
    }
}

@Injectable({
    providedIn: 'root'
})
export class SaveStatusCanDeactivateGuard  {
    constructor(private saveStatusService:SaveStatusService, private localizationService:LocalizationService) {}

    canDeactivate() {
        if(!this.saveStatusService.hasChangedRequests()) {
            return true;
        }
        else {
            if(confirm(this.localizationService.translate('save-status-service.changed-requests'))) {
                return true;
            }
            else return false;
        }
    }
}
